import React from "react";
import {Button, Drawer, Form, Input, Select} from "antd";
import {AddressPost} from "../../../models/marketing/address";

const {TextArea} = Input;
const {Option} = Select;

class AddAddressForm extends React.Component {
  state = {
    data: [],
    responses: [],
    visible: false
  };
  handleAddressForm = () => {
    const {form} = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        AddressPost(values)
          .then(response => {
            this.setState({responses: [...this.state.responses, values]});
            this.handleChange({id: response.id, label: response.address});
            this.setAddAddress(false)
          })
      }
    })
  };


  handleChange = (value) => {
    const data = this.state.data;
    this.setState({
      data: [...data, value],
    });
    this.props.onChange([...data.map(item => item.id), value.id]);
  };

  setAddAddress = (visible) => {
    this.setState({visible})
  };

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {responses} = this.state;
    return (
      <div>
        <Button className="add-phone-btn" onClick={() => this.setAddAddress(true)}><i className="fa fa-plus"/> Add Address</Button>
        {responses.map((item, index) => {
          return <div key={index} className="added-address">
            <p>{item.address}</p>
            {/*<Button className="dlt-btn-card"><i className="fa fa-trash" /></Button>*/}
          </div>
        })}
        <Drawer destroyOnClose={true} title="Add a new address" width={720} onClose={() => this.setAddAddress(false)} visible={this.state.visible}>
          <Form layout="vertical">
            <Form.Item label="Type">
              {getFieldDecorator('type', {
                rules: [{required: true, message: 'Choose type of address'}],
              })(<Select placeholder="Please select an owner">
                <Option value="Home">Home</Option>
                <Option value="Office">Office</Option>
              </Select>,)}
            </Form.Item>
            <Form.Item label="Address">
              {getFieldDecorator('address', {
                rules: [{required: true, message: 'Please enter address'}],
              })(<TextArea style={{width: '100%'}} placeholder="Enter Here"/>,)}
            </Form.Item>
            <Form.Item label="City">
              {getFieldDecorator('city', {
                rules: [{required: true, message: 'Please enter city'}],
              })(<Input placeholder="Enter Here"/>)}
            </Form.Item>
            <Form.Item label="Zip Code">
              {getFieldDecorator('zip_code', {
                rules: [{required: true, message: 'Please enter zip code'}],
              })(<Input placeholder="Enter Here"/>)}
            </Form.Item>
          </Form>
          <Button onClick={this.handleAddressForm} type="primary">
            Submit
          </Button>
        </Drawer>
      </div>
    )
  }
}

export const AddAddress = Form.create()(AddAddressForm);


// WEBPACK FOOTER //
// ./src/pages/ab-marketing/popup/AddAddress.jsx